// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1Xgwo","errorLogs":"styles_errorLogs__1UUML"};